import React from 'react';
import {highlightInMap, clearMapHighlight, clearCarouselFocus} from '../redux';
import {pushEdapEvent} from '../../../utils/edap';
import {goToPinnedSerp, showDatesPopup} from '../../../actions/search';
import {ACTION_LOCATION} from '../events';
import {TESTS} from '../../../utils/abacus';
import {logExperiment} from '@homeaway/abacus-client-utils';

export function sendToEdap(tripleId, types, position, badges) {
    let typesEventRefinements = '';

    if (types) {
        typesEventRefinements = parseInt(types, 10) ? `filter:${types}` : types;
    }

    const badgesEventRefinements =
        badges && parseInt(badges, 10) ? `badge:${badges}` : '';

    const eventPosition = `position:${position}`;

    const eventrefinements = [
        typesEventRefinements,
        badgesEventRefinements,
        eventPosition,
    ]
        .filter(Boolean)
        .join(',');

    const mainData = {
        actionlocation: ACTION_LOCATION,
        listingid: tripleId,
        eventrefinements,
    };

    pushEdapEvent('property.tile.click', mainData);
}

export function onCardClick({
    abacus,
    dispatch,
    listing,
    segmentKey,
    types,
    position,
}) {
    return (evt) => {
        // `evt.defaultPrevented ||`
        // Make sure the trip board button wasn't clicked; or
        // `evt.target.className.includes...`
        // Make sure the event is received by the intended element.
        // prevents a bug in SimpleImageCarousel where fast button clicking causes the event to be handled by the wrong element.
        if (
            evt.defaultPrevented ||
            evt.target.className.includes('ListingsRatioCard__img-container')
        ) {
            return;
        }

        logExperiment(abacus[TESTS.SLPMODALOPTIMIZATION]);

        const {
            propertyName,
            tripleId,
            listingUri,
            currentIndex,
            badgesIds,
        } = listing;

        sendToEdap(tripleId, types, position, badgesIds);

        evt.preventDefault();

        const thumbnailUrlName =
            currentIndex === 0
                ? 'thumbnailUrl'
                : `thumbnailUrl${currentIndex + 1}`;

        dispatch(
            showDatesPopup({
                actionLocation: ACTION_LOCATION,
                eventrefinements: types,
                goToSerpAction: goToPinnedSerp,
                propertyName,
                tripleId,
                listingUri,
                thumbnailUrl: listing[thumbnailUrlName],
                refinementKey: segmentKey,
            })
        );
    };
}

export function onMouseOverCard(dispatch, id) {
    return () => {
        dispatch(highlightInMap(id));
        dispatch(clearCarouselFocus());
    };
}

export function onMouseOutCard(dispatch) {
    return () => {
        dispatch(clearMapHighlight());
    };
}

export function listingAsPropertyRatioCard({
    abacus,
    actionLocation = ACTION_LOCATION,
    dispatch,
    types,
    highlightedId,
    isMobile,
    simpleName,
    tripboardComponent: TripboardComponent,
    segmentKey,
    Card,
}) {
    return (listing, index) => (
        <Card
            actionLocation={actionLocation}
            highlighted={listing.tripleId === highlightedId}
            images={[
                listing.thumbnailUrl,
                listing.thumbnailUrl2,
                listing.thumbnailUrl3,
            ]}
            currentIndex={listing.currentIndex}
            instantBookable={listing.tooltip}
            isMobile={isMobile}
            key={listing.tripleId}
            link={`//${listing.listingUri}`}
            onClick={onCardClick({
                abacus,
                dispatch,
                listing,
                types,
                segmentKey,
                position: index + 1,
            })}
            onMouseOut={onMouseOutCard(dispatch)}
            onMouseOver={onMouseOverCard(dispatch, listing.tripleId)}
            position={index}
            price={listing.price}
            propertyName={listing.propertyName}
            review={listing.review}
            toplineDescription={listing.toplineDescription}
            tripleId={listing.tripleId}
            tripboardComponent={TripboardComponent}
            simpleName={simpleName}
            breadcrumbs={listing.breadcrumbs}
            distanceFrom={listing.distanceFrom}
            badges={listing.badges}
        />
    );
}
